import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectContractorInStore, selectContractorPageLoading, selectContractorShowInitWaitingMessage } from '../_selectors/contractor.selectors';

export class ContractorDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectContractorPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectContractorShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectContractorInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
